import EditorialCardRail from './EditorialCardRail';

export default EditorialCardRail;
